<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">{{modalDetails.title}}</h5>
                <button type="button" class="close btn" data-dismiss="modal" (click)="closeModal()" aria-label="Close">X</button>
            </div>
            <div class="modal-body modal-body-id-cards" id="print-page">
                <ng-container *ngFor="let url of modalDetails.url">
                    <!-- <iframe [width]="this.width" [height]="this.height" [src]="transform(url)" name="iframe_modal"></iframe> -->
                    <iframe *ngIf="!url" [width]="this.width" [height]="this.height" [src]="transform(url)" name="iframe_modal"></iframe>
                    <img *ngIf="url" [src]="url" alt="">
                </ng-container>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn _btn-primary btn-sm" data-dismiss="modal" (click)="closeModal()">Close</button>
                <button type="button" (click)="printView()" class="btn _btn-success btn-sm"><i class="fa fa-print mr5"></i>
                    Print</button>
            </div>
        </div>
    </div>
</div>